import { getToken } from '../../../utils/localStorage';

export default (instance) => {
  instance.interceptors.request.use(function (config) {
    config.headers.Authorization = 'Bearer ' + getToken();
    return Promise.resolve(config);
  });
};
